import { providerType } from '@repo/shared/types';
import { hasMerchantLiberisOffers } from './has-merchant-liberis-offers';
import { providerLimitValues } from './provider-limit-values';
import { providerPreLimitValues } from './provider-pre-limit-values';
export var shouldMerchantFillLiberisOfferData = function (merchantResponseData, loanOfferData) {
    var _a, _b;
    var areLiberisOffersAvailable = hasMerchantLiberisOffers(merchantResponseData);
    var limitValuesLiberis = providerLimitValues(merchantResponseData, providerType.enum.liberis);
    var preLimitValuesLiberis = providerPreLimitValues(merchantResponseData, providerType.enum.liberis);
    return Boolean(!areLiberisOffersAvailable &&
        ((limitValuesLiberis && limitValuesLiberis.available > 0) ||
            (preLimitValuesLiberis && preLimitValuesLiberis.max > 0)) &&
        (!loanOfferData || ((_b = (_a = loanOfferData === null || loanOfferData === void 0 ? void 0 : loanOfferData.data) === null || _a === void 0 ? void 0 : _a.offers) === null || _b === void 0 ? void 0 : _b.length) === 0));
};
